// extracted by css-extract-rspack-plugin
export default {"SplitPageLayout":"Search-module__SplitPageLayout__VgfNAkD","SplitPageLayout_Content":"Search-module__SplitPageLayout_Content__ZxVaf8Y"};